
import Grid from '@material-ui/core/Grid';
import Field from '../Field';

const InfoPanel = props => {
  const { name, address, phone, mobile, relationship } = props;
  const join = (separator, ...items) => items.filter(Boolean).join(separator);
  const longAddress = join(
    ', ',
    join(' ', address.addressLine1, address.addressLine2),
    address.city,
    join(' ', address.state, address.zipCode),
  );
  return (
    <Grid container spacing={2} style={{ flexGrow: 1 }}>
      <Grid item xs={12} id="EmergencyContact-InfoPanel-fullName">
        <Field label="Full Name" value={name} />
      </Grid>
      <Grid item xs={12}>
        <Field label="Address" value={longAddress} />
      </Grid>
      <Grid item xs={12}>
        <Field label="Phone Number" value={phone.cell} />
      </Grid>
      <Grid item xs={12}>
        <Field label="Mobile Number" value={mobile.cell} />
      </Grid>
      <Grid item xs={12}>
        <Field label="Relationship" value={relationship} />
      </Grid>
    </Grid>
  );
};

export default InfoPanel;
